import Carousel from 'react-bootstrap/Carousel';
import React from 'react';
import './hero.css';

const heroData = [
  {
    id: 1,
    image: require('../../../assets/img-hero2.jpeg'),
    title: 'Cursos de Curta Duração para o Sucesso Imediato',
    description: 'Descubra nossos cursos de curta duração, projetados para impulsionar sua carreira e expandir seus horizontes em tempo recorde. Com uma variedade de opções, desde tecnologia até artes, oferecemos aprendizado prático e relevante para o mercado atual. Inscreva-se hoje e dê o próximo passo rumo ao sucesso profissional!',
    link: '/portal-do-estudante/cursos-online'
  },
  {
    id: 2,
    image: require('../../../assets/img-hero1.jpg'),
    title: '4.ª Cerimónia de Outorga de Diplomas',
    description: 'Participe na 4.ª Cerimónia de Outorga de Diplomas do ISP Atlântida, no dia 19 de Dezembro de 2025, no Centro de Conferências de Belas. Venha celebrar connosco a conquista dos nossos finalistas e testemunhar este momento único de reconhecimento, orgulho e inspiração. Não perca — o futuro começa aqui!',
    link: '/noticia/1'
  },
  {
    id: 3,
    image: require('../../../assets/img-hero3.jpg'),
    title: 'Construa seu Futuro Promissor Conosco',
    description: 'No nosso Instituto Superior, preparamos você para os desafios do mundo profissional com qualidade, inovação e dedicação.',
    link: '#'
  },
   {
    id: 4,
    image: require('../../../assets/img-hero2.jpeg'),
    title: 'Cursos de Curta Duração para o Sucesso Imediato',
    description: 'Descubra nossos cursos de curta duração, projetados para impulsionar sua carreira e expandir seus horizontes em tempo recorde. Com uma variedade de opções, desde tecnologia até artes, oferecemos aprendizado prático e relevante para o mercado atual. Inscreva-se hoje e dê o próximo passo rumo ao sucesso profissional!',
    link: '/portal-do-estudante/cursos-online'
  }
];

function AppHero() {
  return (
    <section id="home" className="hero-block">
      <Carousel controls={heroData.length > 1} indicators={heroData.length > 1}>
        {heroData.map(hero => (
          <Carousel.Item key={hero.id}>
            <div className="carousel-image-container">
              <img
                className="d-block w-100"
                src={hero.image}
                alt={`slide ${hero.id}`}
              />
            </div>
            <Carousel.Caption>
              <h2>{hero.title}</h2>
              <p>{hero.description}</p>
              <a className="btn btn-primary" href={hero.link}>
                Leia Mais <i className="fas fa-chevron-right"></i>
              </a>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
    </section>
  );
}

export default AppHero;